import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import store from './store';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import Loading from 'vue-loading-overlay';
import VueRouterBackButton from 'vue-router-back-button'
import VueClipboard from 'vue-clipboard2'
import Notifications from 'vue-notification'
import config from '@/config';

Vue.config.productionTip = false

Vue.use(VueScrollTo);
Vue.use(VueClipboard);
Vue.use(Vuex);
Vue.use(VueRouterBackButton, { router });
Vue.use(VueAxios, axios);
Vue.use(VueScrollTo);
Vue.use(Notifications);

/*config*/
/*id of the current app and related configuration*/
Vue.prototype.$appId = config.appId;
Vue.prototype.$institutionId = config.institutionId;
Vue.prototype.$offerId = config.offerId;
Vue.prototype.$kultourId = config.kultourId;
Vue.prototype.$attractionId = config.attractionId;
Vue.prototype.$backendUrl = config.baseUrl;
Vue.prototype.$backendApiUrl = config.apiBaseUrl;
Vue.prototype.$impressumContentId = config.impressumContentId;
Vue.prototype.$datenschutzContentId = config.datenschutzContentId;
Vue.prototype.$bfeContentId = config.bfeContentId;

import './scss/style.scss';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'material-icons/iconfont/material-icons.css';

/*Initialisieren von Loading*/
Vue.use(Loading, {
  color: 'rgb(148, 192, 31)',
  loader: 'dots',
  width: 140,
  FullPage: true
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
